"use client";

import { useTranslations } from "next-intl";

export function OnlineIndicator({ count }: { count: number }) {
  const t = useTranslations("support_chat");
  const online = count > 0;
  return (
    <div className="flex items-center gap-2 text-xs">
      <span
        className={`inline-block h-2 w-2 rounded-full ${
          online ? "bg-emerald-500" : "bg-neutral-400"
        }`}
        aria-hidden
      />
      <span className="text-neutral-500 dark:text-neutral-400">
        {online ? t("status_online") : t("status_offline")}
      </span>
    </div>
  );
}
